import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { useContext } from 'react';
import { CONSTANTS } from '../../../constants/constants';
import NRSBOMDrawer from '../NRSBOMDrawer/NRSBOMDrawer';
import { FiltersContext } from '../../NRReportTabs/NRReportFilterContextWrapper';
import NRSecondaryLink from '../../../components/NRSecondaryLink/NRSecondaryLink';
import Box from '@mui/material/Box';

const { LOADING } = CONSTANTS.TABLE.MISCONFIGURATION_TABLE.MISCONFIGURATION_DETAIL_DRAWER;
const { DEPENDENCIES } = CONSTANTS.TABLE.SBOM_TABLE.SBOM_DETAIL_DRAWER.TABS;

const DependenciesFormatter = ({ row }) => {
  const { setOpenDrawer, setDrawerContent, drawerContent, setDrawerTitle, drawerTitle, setHasBack } = useContext(FiltersContext);

  const handleOpenDrawer = () => {
    !!drawerContent.length && setHasBack(true);
    setDrawerTitle([...drawerTitle, LOADING]);
    setDrawerContent([...drawerContent, <NRSBOMDrawer row={row} scrollTo={DEPENDENCIES} />]);
    setOpenDrawer(true);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <NRSecondaryLink value={row?.dependency?.sbomDependenciesCount} handleOnClick={() => handleOpenDrawer()} openNull={false} />
    </Box>
  );
};

export const NRSBOMDependenciesProvider = props => <DataTypeProvider formatterComponent={DependenciesFormatter} {...props} />;
